import { render, staticRenderFns } from "./FormatAlignCenterIcon.vue?vue&type=template&id=7ab191b5"
import script from "./FormatAlignCenterIcon.vue?vue&type=script&lang=js"
export * from "./FormatAlignCenterIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports